import axios from "axios";
import Mailjet from "node-mailjet";

const mailApiKey = "881ef43af4c0db03f1439fface6f22fc";
const mailSecretyKey = "a2d8a745ff0f5dd36a3bdd6d509e3a26";
// const host = '72.167.46.56';
const host = "localhost";
const backendPath = `https://charleeadisonnewnode.duckdns.org/api`;
const requestEmailPath = `https://charleeadisonnewnode.duckdns.org/api/email/send-request-demo`;
const learnEmailPath = `https://charleeadisonnewnode.duckdns.org/api/email/send-learn-mode`;
const contactEmailPath = `https://charleeadisonnewnode.duckdns.org/api/email/send-contact-us`;
// const mailjet = Mailjet.apiConnect(
//     mailApiKey,
//     mailSecretyKey
// );

export const sendEmail = async (fromMail, fromName) => {
  console.log(fromMail, fromName);
  axios.post(backendPath, {
    to: fromMail,
    toname: fromName,
    subject: "Request a demo today",
    text: "Sign up for a personalized demo today and see how Charlee can help you stay ahead of potential fraud, mitigate losses, and optimize efficiency.",
    html: "<h1>Request a demo today</h1><p>Sign up for a personalized demo today and see how Charlee can help you stay ahead of potential fraud, mitigate losses, and optimize efficiency.</p>",
  });
};

export const sendContactEmail = async (fromMail, fromName, contactData) => {
  axios.post(contactEmailPath, {
    to: fromMail,
    toname: fromName,
    variables: contactData,
  });
};

export const sendLearnEmail = async (fromMail, fromName, learnData) => {
  axios.post(learnEmailPath, {
    to: fromMail,
    toname: fromName,
    variables: learnData,
  });
};

export const sendRequestEmail = async (fromMail, fromName, requestData) => {
  axios.post(requestEmailPath, {
    to: fromMail,
    toname: fromName,
    variables: requestData,
  });
};
